import { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter';
import z from 'zod';

export type SavedListCampaignCreatorDraftImportItem = {
  id: string;
  username: string;
  platform?: SOURCE_PLATFORM_TYPE | null;
};

const STORAGE_KEY_PREFIX = 'syncly:saved-list-campaign-creator-draft:';

const savedListCampaignCreatorDraftSchema = z.object({
  sourceListId: z.string(),
  creators: z.array(
    z.object({
      id: z.string(),
      username: z.string(),
      platform: z.enum(SOURCE_PLATFORM_TYPE).nullish(),
    }),
  ),
});

export type SavedListCampaignCreatorDraft = {
  sourceListId: string;
  creators: SavedListCampaignCreatorDraftImportItem[];
};

export function createSavedListCampaignCreatorDraftKey() {
  return crypto.randomUUID();
}

export function saveSavedListCampaignCreatorDraft(
  key: string,
  draft: SavedListCampaignCreatorDraft,
) {
  try {
    sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, JSON.stringify(draft));
    return true;
  } catch {
    return false;
  }
}

export function readSavedListCampaignCreatorDraft(
  key: string,
): SavedListCampaignCreatorDraft | null {
  try {
    const value = sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
    if (!value) return null;

    return savedListCampaignCreatorDraftSchema.parse(JSON.parse(value));
  } catch {
    return null;
  }
}
